(() => {
  let podcasts = document.querySelectorAll('[data-podcast]');
  let globalPlayer = null;

  if (podcasts.length) {
    podcasts.forEach(item => {
      const audio = item.querySelector('[data-podcast-audio]'),
        button = item.querySelector('[data-audio-play-btn]'),
        progress = item.querySelector('[data-audio-progress]');

      let itemText = item.querySelector('[data-podcast-text]');
      let audioContainer = item.querySelector('[data-podcast-audio-container]');
      let textFrame = item.querySelector('[data-text-animate-frame]');

      let podcast = {
        animationTimer: null,
        symbols: null,
        speed: 55,
        currentSymbol: 0,
        text: itemText.dataset.content,
        audio: audio,
        button: button,
        status: button.dataset,
        progress: progress,
        setProgressValue(value) {
          this.progress.value = value
        },
        stopText() {
          clearInterval(this.animationTimer);
          this.animationTimer = null;
        },
        resetText() {
          this.stopText();
          this.resetFrame();
        },
        resetPlayer() {
          this.audio.muted = false;
          this.audio.currentTime = 0;
          this.progress.value = 0;
        },
        resetFrame() {
          this.symbols.forEach(symbol => symbol.classList.remove('animated'));
          this.currentSymbol = 0;
        },
        startText() {
          if (!this.animationTimer) {
            this.animationTimer = setInterval(() => {
              if (this.currentSymbol !== this.text.length) {
                this.symbols[this.currentSymbol].classList.add('animated');

                this.setProgressValue(this.currentSymbol / this.text.length);
                this.currentSymbol += 1;
              } else {
                this.setProgressValue(1);
                this.stopText();
              }
            }, this.speed);
          }
        },
        play() {
          if (!globalPlayer) globalPlayer = this;

          if (globalPlayer && globalPlayer !== this) {
            globalPlayer.audio.pause();
            globalPlayer.stopText();
            globalPlayer.status.status = 'play';

            globalPlayer = this;
          }

          if (globalPlayer.audio.paused === false) {
            globalPlayer.audio.pause();
            globalPlayer.status.status = 'play';

            globalPlayer.stopText();
          } else {
            if (globalPlayer.status.status === 'muted' || globalPlayer.status.status === 'repeat') {
              globalPlayer.resetText();
              globalPlayer.resetPlayer();
            }

            globalPlayer.audio.muted = globalPlayer.audio.muted && false;
            globalPlayer.status.status = 'pause';
            globalPlayer.audio.play();
            globalPlayer.startText();
          }
        },
        setAnimationFrameProgress() {
          for (let i = 0; i < this.currentSymbol; i++) {
            this.symbols[i].classList.add('animated');
          }
        },
        seek(event) {
          //TODO - seeking not work on LOCAL/DEV ENV. Can't set currentTime - ByteRange issue -- END
          let percent = event.offsetX / event.target.offsetWidth;
          let currentTime = Math.floor(percent * this.getDuration());
          this.audio.currentTime = currentTime;

          if (this.audio.currentTime === currentTime) {
            this.stopText();
            this.resetFrame();
            this.currentSymbol = Math.floor(percent * this.text.length);
            this.setProgressValue(percent);
            this.setAnimationFrameProgress();
            this.startText();
            this.play();
          }
          else {
            if(!globalPlayer) return;

            this.stopText();
            this.resetFrame();
            this.setProgressValue(0);

            globalPlayer.audio.pause();
            globalPlayer.status.status = 'play';
          }
        },
        calculateSpeed() {
          this.speed = Math.floor((this.getDuration() * 1000) / this.text.length);
        },
        getDuration() {
          return ((
            this.audio.duration !== Infinity && !isNaN(Number(this.audio.duration))
          ) ? this.audio.duration : this.audio.dataset.duration)
        },
        inViewport(el) {
          let rect = el.getBoundingClientRect();

          // Partially visible elements return true:
          //return (elemTop < viewHeight && elemBottom >= 0);

          // Only completely visible elements return true:
          return ((rect.top >= 0) && (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)));
        },
        handleScroll(element) {
          if (this.currentSymbol === this.text.length || this.status.status !== 'muted') return;

          if (this.inViewport(element) && (!globalPlayer || (globalPlayer !== this && globalPlayer.audio.paused))) {
            this.startText();
          } else {
            this.stopText();
          }
        },
        init() {
          [...this.text].forEach(letter => {
            textFrame.innerHTML += '<span style=\'opacity: 0.5\'>' + letter + '</span>';
          });

          this.symbols = textFrame.querySelectorAll(':scope > span');

          this.audio.addEventListener('ended', () => {
            this.currentSymbol === this.text.length && this.stopText();
            this.status.status = 'repeat';
            globalPlayer = null;
          });

          this.button && this.button.addEventListener('click', () => this.play());
          this.button && this.button.addEventListener('keydown', (e) => {
            if (e.keyCode === 32) {
              this.play();
              e.preventDefault();
            }
          });

          document.addEventListener('readystatechange', e => {
            let currentTime = 1;

            //set currentTime for test & enable progress bar
            this.audio.currentTime = currentTime;
            if (e.target.readyState === 'interactive') {
              this.audio.currentTime = currentTime;
            }

            if (e.target.readyState === 'complete') {
              audioContainer.removeAttribute('disabled');

              this.calculateSpeed();

              window.addEventListener('scroll', () => this.handleScroll(item));


              //TODO - seeking not work on LOCAL/DEV ENV. Can't set currentTime - ByteRange issue -- END
              //check if audio can be seeking by click on progress bar
              if (this.audio.currentTime === currentTime)
              {
                this.audio.currentTime = 0;
                this.progress && this.progress.addEventListener("click", e => this.seek(e));
              }
              else
                this.audio.currentTime = 0;
            }
          });
        },
      }

      podcast.init();
    });
  }
})();
